import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Siren } from "lucide-react";

export const UrgentRequestBanner = () => {
  const [a, setA] = useState(null);
  useEffect(() => {
    const load = () => api.get("/client-requests/alerts").then((r) => setA(r.data)).catch(() => {});
    load();
    window.addEventListener("somcore:alerts", load);
    return () => window.removeEventListener("somcore:alerts", load);
  }, []);
  if (!a?.count) return null;
  return (
    <div className="mb-5 rounded-xl border border-red-200 bg-red-50 px-4 py-3" data-testid="urgent-request-banner">
      <div className="flex items-center gap-2 text-sm font-bold text-red-800"><Siren className="h-5 w-5 text-red-600" />{a.count} Urgent Client Request{a.count === 1 ? "" : "s"}</div>
      <div className="mt-2 flex flex-wrap gap-2">
        {a.items.map((o) => (
          <Link key={o.id} to={`/opportunities?open=${o.id}`} className="rounded-md bg-red-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-red-700" data-testid={`urgent-request-open-${o.code}`}>
            {o.code} · {o.client_name}
          </Link>
        ))}
      </div>
    </div>
  );
};
